/**
 * Display helpers for advisor identifiers.
 *
 * Generated advisors carry an internal portal customerId ("adv-52253dbe" or a
 * firm-scoped uuid) with the numeric SIPS id stored separately as sipsTasId.
 * The UI always shows the SIPS id (falling back to the portal id for legacy
 * advisors, whose customerId IS the SIPS id) — the portal id remains the value
 * stored/submitted everywhere.
 */

interface AdvisorIdSource {
  customerId: string;
  sipsTasId?: string | null;
  name?: string;
}

/** The id to DISPLAY for an advisor: sipsTasId when known, else the raw id. */
export function advisorDisplayId(configs: AdvisorIdSource[], customerId: string): string {
  const cfg = configs.find((c) => c.customerId === customerId);
  return String(cfg?.sipsTasId || customerId);
}

/** "1008 — Carter Jones" style label; falls back to the raw id when unknown. */
export function advisorDisplayLabel(configs: AdvisorIdSource[], customerId: string): string {
  const cfg = configs.find((c) => c.customerId === customerId);
  if (!cfg) return customerId;
  return `${String(cfg.sipsTasId || cfg.customerId)} — ${cfg.name || 'Unnamed advisor'}`;
}
